import api from '../../../api/axios';

export interface Practitioner {
  id: number;
  name: string;
  cliniko_id: string;
  title: string;
  specialties: string;
  description: string;
  photo_url: string | null;
  is_active: boolean;
  sort_order: number;
  created_at: string;
  updated_at: string;
}

// Get all practitioners
export const getPractitioners = async () => {
  try {
    const response = await api.get('/api/admin/practitioners');
    return response.data;
  } catch (error) {
    console.error('Error fetching practitioners:', error);
    throw error;
  }
};

// Get single practitioner by ID
export const getPractitionerById = async (id: number) => {
  try {
    const response = await api.get(`/api/admin/practitioners/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching practitioner ${id}:`, error);
    throw error;
  }
};

// Create new practitioner
export const createPractitioner = async (practitionerData: Partial<Practitioner>) => {
  try {
    const response = await api.post('/api/admin/practitioners', practitionerData);
    return response.data;
  } catch (error) {
    console.error('Error creating practitioner:', error);
    throw error;
  }
};

// Update existing practitioner
export const updatePractitioner = async (id: number, practitionerData: Partial<Practitioner>) => {
  try {
    const response = await api.put(`/api/admin/practitioners/${id}`, practitionerData);
    return response.data;
  } catch (error) {
    console.error(`Error updating practitioner ${id}:`, error);
    throw error;
  }
};

// Delete practitioner
export const deletePractitioner = async (id: number) => {
  try {
    const response = await api.delete(`/api/admin/practitioners/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting practitioner ${id}:`, error);
    throw error;
  }
};

// Get cliniko practitioners
export const getClinikoPractitioners = async () => {
  try {
    const response = await api.get('/api/cliniko/raw-practitioners');
    return response.data;
  } catch (error) {
    console.error('Error fetching Cliniko practitioners:', error);
    throw error;
  }
};
